import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'filterByWastes'
})
export class FilterByWastesPipe implements PipeTransform {

  transform(items: any, wastes: string[]): any {
    if (wastes.length === 0) {
      return items;
    } else {
          return items.filter(item => typeof(item.wastes.find(element => wastes.includes(element))) !== 'undefined');
      }
    }

  }





// WEBPACK FOOTER //
// /Users/julien/code/urbyn/urbyn-backoffice/src/app/haulers/filters/filter-by-wastes.pipe.ts